export default async function ({ route, redirect }) {
  if (route.name === 'member') {
    redirect({ name: 'member-orderList' })
  }
}
